import React, { useMemo, useRef } from 'react';
import Icon, { IconType } from '../../icons/Icon';

type Size = 'md' | 'sm';

interface ToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
  size?: Size;
}

export default function Toggle({ value, onChange, size = 'md' }: ToggleProps) {
  const ref = useRef<HTMLInputElement>(null);

  const background = value ? 'bg-success-600' : 'bg-gray-600';
  // const position = value ? 'translate-x-5' : 'translate-x-0';

  const position = useMemo(() => {
    if (!value) return 'translate-x-0';

    return {
      md: 'translate-x-5',
      sm: 'translate-x-4',
    }[size];
  }, [value, size]);

  const toggleSize = {
    md: 'h-5 w-10',
    sm: 'h-4 w-8',
  }[size];

  const iconSize = {
    md: 'size-4',
    sm: 'size-3',
  }[size];

  const circleSize = {
    md: 'size-4',
    sm: 'size-3.5',
  }[size];

  const circleMargin = {
    md: 'm-[2px]',
    sm: 'm-[1px]',
  }[size];

  return (
    <label
      className={`${background} relative flex ${toggleSize} cursor-pointer rounded-[100px] stroke-white transition-all duration-200 focus-within:ring-2 focus-within:ring-opacity-100`}
    >
      <Icon type={IconType.check} size={iconSize} className={`my-[2px] ml-1 flex-1`} />
      <Icon type={IconType.x} size={iconSize} className={`my-[2px] mr-1 flex-1`} />
      <div
        className={`absolute transition-all duration-200 ${position} ${circleMargin} ${circleSize} rounded-full bg-white`}
      ></div>
      <input
        ref={ref}
        type='checkbox'
        checked={value}
        onChange={event => onChange(event.currentTarget.checked)}
        className='h-0 w-0 rounded-full opacity-0 focus:outline-none'
      />
    </label>
  );
}
